module.exports = () => {
  return {
    type: {
      type: 'select',
      is_filter: true,
      props: {
        clearable: false,
      },
      options: [
        { label: '广告名称', value: 'campaign_name' },
        { label: '广告ID', value: 'campaign_id' },
      ],
      value: 'campaign_name',
    },
    campaign_name: {
      type: 'input',
      hidden: false,
      props: {
        placeholder: '请输入广告名称',
      },
      value: '',
    },
    campaign_id: {
      type: 'input',
      hidden: true,
      props: {
        placeholder: '请输入广告ID',
      },
      value: '',
    },
    site_sets: {
      label: '广告版位',
      type: 'select',
      hidden: false,
      props: {
        disabled: false,
        multiple: true,
      },
      options: [],
      value: [],
    },
    site_set_type: {
      label: '仅显示自动版位',
      type: 'checkbox',
      hidden: false,
      props: {
        trueLabel: '1',
        falseLabel: '2',
      },
      value: '2',
    },
  };
};
